import { createFileRoute, redirect } from '@tanstack/react-router';
import EventCompose from './-compose';
import { genMeta } from '../../../utils/meta';
import { getSessionUser } from '../../../actions/getSessionUser';

export const Route = createFileRoute('/event/compose/')({
  component: EventCompose,
  head(ctx) {
    return genMeta({
      title: 'New Event',
      description: 'Create a new event',
      // TODO REMOVE WHEN EVENTS ARE LIVE
      other: [{ name: 'robots', content: 'noindex' }],
    });
  },
  beforeLoad: async () => {
    const user = await getSessionUser();
    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
    if (user.role !== 'ADMIN') {
      throw redirect({ to: '/' });
    }
  },
});
